import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions'
import 'firebase/storage';
import 'firebase/analytics';
// const admin = require('firebase-admin');
// const FieldValue = admin.firestore.FieldValue;

function getFirebaseConfig() {
  const env = process.env.NODE_ENV;
  const deploy_env = process.env.REACT_APP_DEPLOY_ENV;
  console.log("NODE_ENV: ", env);
  console.log("DEPLOY_ENV: ", deploy_env);
  if(env === 'production' && deploy_env === 'prod') {
    console.log("Using Firebase prod config...");
    return prodConfig;
  } // env === 'development' or 'test' or env === 'production' && deploy_env === 'dev'
  console.log("Using Firebase dev config...");
  return devConfig;
}

const devConfig = {
  apiKey: "AIzaSyAGM4RjUgU6zfs6VShUz6Fzq9Odsy_lxw8",
  authDomain: "sitetrace-dev.firebaseapp.com",
  projectId: "sitetrace-dev",
  storageBucket: "sitetrace-dev.appspot.com",
  messagingSenderId: "1039505947525",
  appId: "1:1039505947525:web:bca52941a664c748d8a2ec",
  measurementId: "G-J62VEQN4ZZ"
};

const prodConfig = {
  apiKey: "AIzaSyDILQzqqfUgyAOHC1_1T5Dsu31jrgOR0Ws",
  authDomain: "sitetrace-prod.firebaseapp.com",
  projectId: "sitetrace-prod",
  storageBucket: "sitetrace-prod.appspot.com",
  messagingSenderId: "304727621411",
  appId: "1:304727621411:web:d30a2a7f9c318da90e9696",
  measurementId: "G-T7CWRNM0LQ"
};

if (!firebase.apps.length) {
  const firebaseConfig = getFirebaseConfig();
  firebase.initializeApp(firebaseConfig);
  firebase.firestore().enablePersistence({experimentalTabSynchronization:true})
  .catch((err) => {
    console.log(err)
      if (err.code == 'failed-precondition') {
          // Multiple tabs open, persistence can only be enabled
          // in one tab at a a time.
          // ...
      } else if (err.code == 'unimplemented') {
          // The current browser does not support all of the
          // features required to enable persistence
          // ...
      }
  });
} 
// else {
//      firebase.app();
// }


const analytics= firebase.analytics();


var functions = firebase.functions();

export { firebase, analytics, functions };
